import React, { useState, useEffect } from 'react';

const NecrovaLogin = () => {
  // State for form inputs
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [loadingAnimation, setLoadingAnimation] = useState(false);

  // Fake user database - add your fake logins here
  const fakeUsers = [
    { username: 'admin', password: 'admin123', redirectTo: 'https://4fingerstudios.com/Employee-Portal' },
    { username: 'lunix', password: 'founder', redirectTo: 'https://4fingerstudios.com/Employee-Portal' },
    { username: 'james', password: 'science', redirectTo: 'https://4fingerstudios.com/Employee-Portal' },
    { username: 'jane', password: 'twins', redirectTo: 'https://4fingerstudios.com/Employee-Portal' },
    { username: 'guest', password: 'guest', redirectTo: 'https://4fingerstudios.com/Coming-Soon' }
  ];

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage('');
    setLoadingAnimation(true);
    
    // Simulate network delay
    setTimeout(() => {
      const user = fakeUsers.find(
        user => user.username === username && user.password === password
      );
      
      if (user) {
        setLoginSuccess(true);
        // Redirect after successful animation
        setTimeout(() => {
          window.location.href = user.redirectTo;
        }, 1500);
      } else {
        setErrorMessage('Invalid credentials. Access denied.');
        setLoadingAnimation(false);
      }
    }, 1200);
  };

  // Handle enter key press
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <div className="necrova-login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="logo-container">
          <img 
          src="https://cdn.4fingerstudios.com/Necrova/NecrovaStuffas/Full.png" 
          width="60" 
          height="60" 
          alt="Description of image"
        />
            <h1 className="company-title">NECROVA</h1>
          </div>
          <h2 className="login-title">Secure Access Portal</h2>
        </div>

        <div className="login-body">
          {!loginSuccess ? (
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  onKeyPress={handleKeyPress}
                  required
                  autoComplete="off"
                />
                <div className="input-focus-border"></div>
              </div>

              <div className="input-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyPress={handleKeyPress}
                  required
                />
                <div className="input-focus-border"></div>
              </div>

              {errorMessage && (
                <div className="error-message">
                  <span className="error-icon">!</span>
                  {errorMessage}
                </div>
              )}

              <div className="form-footer">
                <button 
                  type="submit" 
                  className="login-button"
                  disabled={loadingAnimation}
                >
                  {loadingAnimation ? (
                    <div className="loading-spinner">
                      <div className="spinner"></div>
                      <span>Authenticating...</span>
                    </div>
                  ) : (
                    'Login'
                  )}
                </button>
              </div>
            </form>
          ) : (
            <div className="success-message">
              <div className="success-icon">
                <svg viewBox="0 0 50 50" width="40" height="40">
                  <circle cx="25" cy="25" r="20" fill="#8a2be2" />
                  <path d="M15,25 L22,32 L35,18" stroke="white" strokeWidth="3" fill="none" />
                </svg>
              </div>
              <p>Access granted! Redirecting...</p>
              <div className="loading-bar">
                <div className="loading-progress"></div>
              </div>
            </div>
          )}
        </div>

        <div className="login-footer">
          <p className="footer-text">NECROVA INDUSTRIES • CONFIDENTIAL • AUTHORIZED ACCESS ONLY</p>
          <p className="system-info">SYSTEM V2.3.7 • {new Date().getFullYear()}</p>
        </div>
      </div>

      <div className="decorative-elements">
        <div className="moving-particles"></div>
        <div className="circuit-lines"></div>
      </div>

      <style jsx>{`
        /* Global styles */
        .necrova-login-container {
          font-family: 'Arial', sans-serif;
          margin: 0;
          padding: 0;
          color: white;
          background: linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 50%, #16213e 100%);
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          overflow: hidden;
        }

        /* Login card */
        .login-card {
          background-color: rgba(15, 15, 26, 0.8);
          border-radius: 10px;
          border: 1px solid rgba(138, 43, 226, 0.3);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
          width: 90%;
          max-width: 450px;
          padding: 2rem;
          backdrop-filter: blur(5px);
          animation: cardAppear 0.5s ease-out;
          position: relative;
          z-index: 10;
        }

        @keyframes cardAppear {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Card header */
        .login-header {
          text-align: center;
          margin-bottom: 2rem;
        }

        .logo-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 1rem;
        }

        .company-title {
          font-size: 2rem;
          font-weight: bold;
          letter-spacing: 3px;
          margin: 0.5rem 0;
          color: white;
        }

        .login-title {
          font-size: 1.2rem;
          color: #e94560;
          font-weight: normal;
          letter-spacing: 1px;
          position: relative;
          display: inline-block;
        }

        .login-title::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 50px;
          height: 2px;
          background: linear-gradient(90deg, #8a2be2, #e94560);
        }

        /* Form styling */
        .login-body {
          margin-bottom: 2rem;
        }

        .input-group {
          margin-bottom: 1.5rem;
          position: relative;
        }

        label {
          display: block;
          margin-bottom: 0.5rem;
          font-size: 0.9rem;
          color: #8a8aaa;
        }

        input {
          width: 100%;
          padding: 0.8rem;
          background-color: rgba(26, 26, 46, 0.5);
          border: 1px solid rgba(138, 43, 226, 0.3);
          border-radius: 4px;
          color: white;
          font-size: 1rem;
          transition: all 0.3s ease;
          outline: none;
        }

        input:focus {
          border-color: #8a2be2;
          box-shadow: 0 0 0 2px rgba(138, 43, 226, 0.2);
        }

        .input-focus-border {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, #8a2be2, #e94560);
          transition: width 0.3s ease;
        }

        input:focus + .input-focus-border {
          width: 100%;
        }

        /* Error message */
        .error-message {
          background-color: rgba(233, 69, 96, 0.2);
          border-left: 3px solid #e94560;
          color: #e94560;
          padding: 0.8rem;
          margin-bottom: 1.5rem;
          display: flex;
          align-items: center;
          animation: errorShake 0.4s ease-in-out;
        }

        .error-icon {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 20px;
          height: 20px;
          background-color: #e94560;
          color: white;
          border-radius: 50%;
          margin-right: 10px;
          font-weight: bold;
        }

        @keyframes errorShake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }

        /* Login button */
        .form-footer {
          display: flex;
          justify-content: center;
        }

        .login-button {
          padding: 0.8rem 2.5rem;
          background: linear-gradient(90deg, #8a2be2, #e94560);
          border: none;
          color: white;
          border-radius: 4px;
          cursor: pointer;
          font-size: 1rem;
          font-weight: bold;
          transition: all 0.3s ease;
          min-width: 150px;
          position: relative;
          overflow: hidden;
        }

        .login-button:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(138, 43, 226, 0.5);
        }

        .login-button:active:not(:disabled) {
          transform: translateY(0);
          box-shadow: 0 2px 4px rgba(138, 43, 226, 0.5);
        }

        .login-button:disabled {
          opacity: 0.8;
          cursor: default;
        }

        /* Loading spinner */
        .loading-spinner {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .spinner {
          width: 20px;
          height: 20px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          border-top-color: white;
          animation: spin 1s linear infinite;
          margin-right: 10px;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        /* Success message */
        .success-message {
          text-align: center;
          padding: 1rem;
          animation: successFade 0.5s ease-in;
        }

        .success-icon {
          margin: 0 auto 1rem;
          animation: successPulse 1.5s infinite;
        }

        .loading-bar {
          height: 4px;
          background-color: rgba(138, 43, 226, 0.2);
          border-radius: 2px;
          margin-top: 1rem;
          overflow: hidden;
        }

        .loading-progress {
          height: 100%;
          background: linear-gradient(90deg, #8a2be2, #e94560);
          width: 0;
          animation: loadProgress 1.5s forwards;
        }

        @keyframes successPulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }

        @keyframes loadProgress {
          to { width: 100%; }
        }

        @keyframes successFade {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        /* Footer styling */
        .login-footer {
          text-align: center;
          border-top: 1px solid rgba(138, 43, 226, 0.3);
          padding-top: 1rem;
        }

        .footer-text {
          font-size: 0.8rem;
          color: #8a8aaa;
          margin-bottom: 0.5rem;
        }

        .system-info {
          font-size: 0.7rem;
          color: #8a8aaa;
          letter-spacing: 1px;
        }

        /* Decorative elements */
        .decorative-elements {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          z-index: 1;
        }

        .moving-particles::before,
        .moving-particles::after {
          content: '';
          position: absolute;
          background-color: rgba(138, 43, 226, 0.1);
          border-radius: 50%;
        }

        .moving-particles::before {
          width: 200px;
          height: 200px;
          top: -100px;
          right: -50px;
          animation: moveParticle1 15s infinite alternate;
        }

        .moving-particles::after {
          width: 300px;
          height: 300px;
          bottom: -150px;
          left: -100px;
          animation: moveParticle2 20s infinite alternate;
        }

        .circuit-lines::before,
        .circuit-lines::after {
          content: '';
          position: absolute;
          background: linear-gradient(90deg, transparent, rgba(138, 43, 226, 0.1), transparent);
          height: 1px;
        }

        .circuit-lines::before {
          width: 60%;
          top: 30%;
          left: 0;
          animation: moveLine1 8s infinite alternate;
        }

        .circuit-lines::after {
          width: 40%;
          bottom: 40%;
          right: 0;
          animation: moveLine2 12s infinite alternate;
        }

        @keyframes moveParticle1 {
          from { transform: translateY(0) rotate(0deg); }
          to { transform: translateY(150px) rotate(30deg); }
        }

        @keyframes moveParticle2 {
          from { transform: translateY(0) rotate(0deg); }
          to { transform: translateY(120px) rotate(-20deg); }
        }

        @keyframes moveLine1 {
          from { transform: translateX(0); }
          to { transform: translateX(20%); }
        }

        @keyframes moveLine2 {
          from { transform: translateX(0); }
          to { transform: translateX(-15%); }
        }

        /* Responsive styles */
        @media (max-width: 600px) {
          .login-card {
            padding: 1.5rem;
            width: 95%;
          }
          
          .company-title {
            font-size: 1.8rem;
          }
          
          .login-title {
            font-size: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default NecrovaLogin;